const TARGET_TICK_COUNT = 8;
const DENSE_TARGET_TICK_COUNT = 14;
const MAX_ALL_LABEL_POINTS = 14;

const buildTickIndexes = (totalPoints: number, targetTickCount: number): Set<number> => {
  const tickIndexes = new Set<number>();
  for (let tickIndex = 0; tickIndex < targetTickCount; tickIndex += 1) {
    const position = Math.round((tickIndex * (totalPoints - 1)) / (targetTickCount - 1));
    tickIndexes.add(position);
  }

  return tickIndexes;
};

export const buildTickLabelInterval = (
  totalPoints: number,
): ((value: string, index: number) => boolean) | 'auto' => {
  if (totalPoints <= TARGET_TICK_COUNT) return 'auto';
  const tickIndexes = buildTickIndexes(totalPoints, TARGET_TICK_COUNT);

  return (_value: string, index: number) => tickIndexes.has(index);
};

export const buildAdaptiveTickLabelInterval = (
  totalPoints: number,
  preferAllLabels: boolean,
): ((value: string, index: number) => boolean) | 'auto' => {
  if (!preferAllLabels) return buildTickLabelInterval(totalPoints);
  if (totalPoints <= MAX_ALL_LABEL_POINTS) return showEveryTickLabel;
  const tickIndexes = buildTickIndexes(totalPoints, DENSE_TARGET_TICK_COUNT);

  return (_value: string, index: number) => tickIndexes.has(index);
};

export const showEveryTickLabel = (): boolean => true;
